/**
 * Work around Vue's restriction in embedding <style> tags.
 * Useful for dynamically styling pseudoelements which can't via attribute binding.
 * <v-style>...</v-style> renders as <style>...</style>
 */
import Vue from '../externals/vue';

export default Vue.component('v-style', {
  functional: true,
  render: function(createElement, context) {
    return createElement('style', context.slots().default);
  },
});
